<template>
  <el-form ref="form" :model="form">
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.customerCompanyID"
            @on-created="mixCreateCustomer"
            @on-change="onChangeCompanyID"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model.sync="form.customerCompanyDetailID"
            @update:model="autoSave('customerCompanyDetailID')"
            :companyID="form.customerCompanyID"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.customerContactID"
            :companyID="form.customerCompanyID"
            @update:model="autoSave('customerContactID')"
          ></select-company-contact>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.rfqTypeID"
            @update:model="autoSave('rfqTypeID', { required: true })"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('employee')"
          :rules="getValidationRule('required')"
          prop="baxEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.baxEmployeeID"
            @update:model="autoSave('baxEmployeeID', { required: true })"
            :fields="{ id: 'id', title: 'name'}"
            :isLoading="dataSourceEmployee.loading"
            :data="dataSourceEmployee.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('priority')"
          :rules="getValidationRule('required')"
          prop="priorityID"
          class="material-style">
          <select-response
            :model.sync="form.priorityID"
            @update:model="autoSave('priorityID', { required: true })"
            :isLoading="dataSourcePriority.loading"
            :data="dataSourcePriority.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            v-model="form.observation"
            @change="autoSave('observation', { required: true })"
          ></el-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mixUpdateCustomer } from '@/mixins/companies'
import Form from '@/components/Form/Form'

export default {
  name: 'FromRFQ',
  mixins: [Form, mixUpdateCustomer],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  created () {
    this.$bus.$onPromise('getRFQFormData', this.listenerGetData)
  },
  beforeDestroy () {
    this.$bus.$offPromise('getRFQFormData', this.listenerGetData)
  },
  computed: {
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name&filter=isActive==true')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    }
  },
  methods: {
    listenerGetData () {
      return this.getData()
    },
    onChangeCompanyID (id) {
      this.mixChangeCustomerID(id, { required: true })
      this.$emit('onChangeCompanyID', id)
    }
  }
}
</script>
